import axios from "axios";
import config from "../config";

const apiURL = config("API_URL");

const SearchServices = {
  async getEvents(query, locale, country, region, dateRefinementObj) {
    const response = await axios.get(`${apiURL}/search/${country}/${region}`, {
      params: {
        query,
        locale,
        dateRefinementObj
      }
    });
    return response.data;
  },
  async getTags(userId, locale) {
    const response = await axios.get(`${apiURL}/search/tags/${userId}`, {
      params: {
        locale
      }
    });
    return response.data.tags;
  }
};

export default SearchServices;
